/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReferenceRouteImport } from './routes/reference'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as HelpRouteImport } from './routes/help'
import { Route as DataRouteImport } from './routes/_data'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as LibraryIndexRouteImport } from './routes/library.index'
import { Route as HelpIndexRouteImport } from './routes/help.index'
import { Route as DataIndexRouteImport } from './routes/_data.index'
import { Route as SettingsViewersRouteImport } from './routes/settings.viewers'
import { Route as SettingsStorageRouteImport } from './routes/settings.storage'
import { Route as SettingsServicesRouteImport } from './routes/settings.services'
import { Route as SettingsHelpRouteImport } from './routes/settings.help'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsAccountRouteImport } from './routes/settings.account'
import { Route as ReferenceEnzymesRouteImport } from './routes/reference.enzymes'
import { Route as LibraryPrimersRouteImport } from './routes/library.primers'
import { Route as HelpCompletionRouteImport } from './routes/help.completion'
import { Route as HelpTopicIdRouteImport } from './routes/help.$topicId'
import { Route as DataSplatRouteImport } from './routes/_data.$'
import { Route as DataViewFileIdRouteImport } from './routes/_data.view.$fileId'
import { Route as DataViewFileIdIndexRouteImport } from './routes/_data.view.$fileId.index'
import { Route as DataViewFileIdSearchesRouteImport } from './routes/_data.view.$fileId.searches'
import { Route as DataViewFileIdPrimersRouteImport } from './routes/_data.view.$fileId.primers'
import { Route as DataViewFileIdHistoryRouteImport } from './routes/_data.view.$fileId.history'
import { Route as DataViewFileIdHeatmapRouteImport } from './routes/_data.view.$fileId.heatmap'
import { Route as DataViewFileIdFeaturesRouteImport } from './routes/_data.view.$fileId.features'
import { Route as DataViewFileIdDotplotRouteImport } from './routes/_data.view.$fileId.dotplot'
import { Route as DataViewFileIdSequenceSequenceIdRouteImport } from './routes/_data.view.$fileId_.sequence.$sequenceId'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferenceRoute = ReferenceRouteImport.update({
  id: '/reference',
  path: '/reference',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const DataRoute = DataRouteImport.update({
  id: '/_data',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const LibraryIndexRoute = LibraryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LibraryRoute,
} as any)
const HelpIndexRoute = HelpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HelpRoute,
} as any)
const DataIndexRoute = DataIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DataRoute,
} as any)
const SettingsViewersRoute = SettingsViewersRouteImport.update({
  id: '/viewers',
  path: '/viewers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsStorageRoute = SettingsStorageRouteImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsServicesRoute = SettingsServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsHelpRoute = SettingsHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRoute,
} as any)
const ReferenceEnzymesRoute = ReferenceEnzymesRouteImport.update({
  id: '/enzymes',
  path: '/enzymes',
  getParentRoute: () => ReferenceRoute,
} as any)
const LibraryPrimersRoute = LibraryPrimersRouteImport.update({
  id: '/primers',
  path: '/primers',
  getParentRoute: () => LibraryRoute,
} as any)
const HelpCompletionRoute = HelpCompletionRouteImport.update({
  id: '/completion',
  path: '/completion',
  getParentRoute: () => HelpRoute,
} as any)
const HelpTopicIdRoute = HelpTopicIdRouteImport.update({
  id: '/$topicId',
  path: '/$topicId',
  getParentRoute: () => HelpRoute,
} as any)
const DataSplatRoute = DataSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => DataRoute,
} as any)
const DataViewFileIdRoute = DataViewFileIdRouteImport.update({
  id: '/view/$fileId',
  path: '/view/$fileId',
  getParentRoute: () => DataRoute,
} as any)
const DataViewFileIdIndexRoute = DataViewFileIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DataViewFileIdRoute,
} as any)
const DataViewFileIdSearchesRoute = DataViewFileIdSearchesRouteImport.update({
  id: '/searches',
  path: '/searches',
  getParentRoute: () => DataViewFileIdRoute,
} as any)
const DataViewFileIdPrimersRoute = DataViewFileIdPrimersRouteImport.update({
  id: '/primers',
  path: '/primers',
  getParentRoute: () => DataViewFileIdRoute,
} as any)
const DataViewFileIdHistoryRoute = DataViewFileIdHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => DataViewFileIdRoute,
} as any)
const DataViewFileIdHeatmapRoute = DataViewFileIdHeatmapRouteImport.update({
  id: '/heatmap',
  path: '/heatmap',
  getParentRoute: () => DataViewFileIdRoute,
} as any)
const DataViewFileIdFeaturesRoute = DataViewFileIdFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => DataViewFileIdRoute,
} as any)
const DataViewFileIdDotplotRoute = DataViewFileIdDotplotRouteImport.update({
  id: '/dotplot',
  path: '/dotplot',
  getParentRoute: () => DataViewFileIdRoute,
} as any)
const DataViewFileIdSequenceSequenceIdRoute =
  DataViewFileIdSequenceSequenceIdRouteImport.update({
    id: '/view/$fileId_/sequence/$sequenceId',
    path: '/view/$fileId/sequence/$sequenceId',
    getParentRoute: () => DataRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof DataIndexRoute
  '/help': typeof HelpRouteWithChildren
  '/library': typeof LibraryRouteWithChildren
  '/reference': typeof ReferenceRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/$': typeof DataSplatRoute
  '/help/$topicId': typeof HelpTopicIdRoute
  '/help/completion': typeof HelpCompletionRoute
  '/library/primers': typeof LibraryPrimersRoute
  '/reference/enzymes': typeof ReferenceEnzymesRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/help': typeof SettingsHelpRoute
  '/settings/services': typeof SettingsServicesRoute
  '/settings/storage': typeof SettingsStorageRoute
  '/settings/viewers': typeof SettingsViewersRoute
  '/help/': typeof HelpIndexRoute
  '/library/': typeof LibraryIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/view/$fileId': typeof DataViewFileIdRouteWithChildren
  '/view/$fileId/dotplot': typeof DataViewFileIdDotplotRoute
  '/view/$fileId/features': typeof DataViewFileIdFeaturesRoute
  '/view/$fileId/heatmap': typeof DataViewFileIdHeatmapRoute
  '/view/$fileId/history': typeof DataViewFileIdHistoryRoute
  '/view/$fileId/primers': typeof DataViewFileIdPrimersRoute
  '/view/$fileId/searches': typeof DataViewFileIdSearchesRoute
  '/view/$fileId/': typeof DataViewFileIdIndexRoute
  '/view/$fileId/sequence/$sequenceId': typeof DataViewFileIdSequenceSequenceIdRoute
}
export interface FileRoutesByTo {
  '/reference': typeof ReferenceRouteWithChildren
  '/$': typeof DataSplatRoute
  '/help/$topicId': typeof HelpTopicIdRoute
  '/help/completion': typeof HelpCompletionRoute
  '/library/primers': typeof LibraryPrimersRoute
  '/reference/enzymes': typeof ReferenceEnzymesRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/help': typeof SettingsHelpRoute
  '/settings/services': typeof SettingsServicesRoute
  '/settings/storage': typeof SettingsStorageRoute
  '/settings/viewers': typeof SettingsViewersRoute
  '/': typeof DataIndexRoute
  '/help': typeof HelpIndexRoute
  '/library': typeof LibraryIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/view/$fileId/dotplot': typeof DataViewFileIdDotplotRoute
  '/view/$fileId/features': typeof DataViewFileIdFeaturesRoute
  '/view/$fileId/heatmap': typeof DataViewFileIdHeatmapRoute
  '/view/$fileId/history': typeof DataViewFileIdHistoryRoute
  '/view/$fileId/primers': typeof DataViewFileIdPrimersRoute
  '/view/$fileId/searches': typeof DataViewFileIdSearchesRoute
  '/view/$fileId': typeof DataViewFileIdIndexRoute
  '/view/$fileId/sequence/$sequenceId': typeof DataViewFileIdSequenceSequenceIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_data': typeof DataRouteWithChildren
  '/help': typeof HelpRouteWithChildren
  '/library': typeof LibraryRouteWithChildren
  '/reference': typeof ReferenceRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/_data/$': typeof DataSplatRoute
  '/help/$topicId': typeof HelpTopicIdRoute
  '/help/completion': typeof HelpCompletionRoute
  '/library/primers': typeof LibraryPrimersRoute
  '/reference/enzymes': typeof ReferenceEnzymesRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/help': typeof SettingsHelpRoute
  '/settings/services': typeof SettingsServicesRoute
  '/settings/storage': typeof SettingsStorageRoute
  '/settings/viewers': typeof SettingsViewersRoute
  '/_data/': typeof DataIndexRoute
  '/help/': typeof HelpIndexRoute
  '/library/': typeof LibraryIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/_data/view/$fileId': typeof DataViewFileIdRouteWithChildren
  '/_data/view/$fileId/dotplot': typeof DataViewFileIdDotplotRoute
  '/_data/view/$fileId/features': typeof DataViewFileIdFeaturesRoute
  '/_data/view/$fileId/heatmap': typeof DataViewFileIdHeatmapRoute
  '/_data/view/$fileId/history': typeof DataViewFileIdHistoryRoute
  '/_data/view/$fileId/primers': typeof DataViewFileIdPrimersRoute
  '/_data/view/$fileId/searches': typeof DataViewFileIdSearchesRoute
  '/_data/view/$fileId/': typeof DataViewFileIdIndexRoute
  '/_data/view/$fileId_/sequence/$sequenceId': typeof DataViewFileIdSequenceSequenceIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/help'
    | '/library'
    | '/reference'
    | '/settings'
    | '/$'
    | '/help/$topicId'
    | '/help/completion'
    | '/library/primers'
    | '/reference/enzymes'
    | '/settings/account'
    | '/settings/general'
    | '/settings/help'
    | '/settings/services'
    | '/settings/storage'
    | '/settings/viewers'
    | '/help/'
    | '/library/'
    | '/settings/'
    | '/view/$fileId'
    | '/view/$fileId/dotplot'
    | '/view/$fileId/features'
    | '/view/$fileId/heatmap'
    | '/view/$fileId/history'
    | '/view/$fileId/primers'
    | '/view/$fileId/searches'
    | '/view/$fileId/'
    | '/view/$fileId/sequence/$sequenceId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/reference'
    | '/$'
    | '/help/$topicId'
    | '/help/completion'
    | '/library/primers'
    | '/reference/enzymes'
    | '/settings/account'
    | '/settings/general'
    | '/settings/help'
    | '/settings/services'
    | '/settings/storage'
    | '/settings/viewers'
    | '/'
    | '/help'
    | '/library'
    | '/settings'
    | '/view/$fileId/dotplot'
    | '/view/$fileId/features'
    | '/view/$fileId/heatmap'
    | '/view/$fileId/history'
    | '/view/$fileId/primers'
    | '/view/$fileId/searches'
    | '/view/$fileId'
    | '/view/$fileId/sequence/$sequenceId'
  id:
    | '__root__'
    | '/_data'
    | '/help'
    | '/library'
    | '/reference'
    | '/settings'
    | '/_data/$'
    | '/help/$topicId'
    | '/help/completion'
    | '/library/primers'
    | '/reference/enzymes'
    | '/settings/account'
    | '/settings/general'
    | '/settings/help'
    | '/settings/services'
    | '/settings/storage'
    | '/settings/viewers'
    | '/_data/'
    | '/help/'
    | '/library/'
    | '/settings/'
    | '/_data/view/$fileId'
    | '/_data/view/$fileId/dotplot'
    | '/_data/view/$fileId/features'
    | '/_data/view/$fileId/heatmap'
    | '/_data/view/$fileId/history'
    | '/_data/view/$fileId/primers'
    | '/_data/view/$fileId/searches'
    | '/_data/view/$fileId/'
    | '/_data/view/$fileId_/sequence/$sequenceId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DataRoute: typeof DataRouteWithChildren
  HelpRoute: typeof HelpRouteWithChildren
  LibraryRoute: typeof LibraryRouteWithChildren
  ReferenceRoute: typeof ReferenceRouteWithChildren
  SettingsRoute: typeof SettingsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reference': {
      id: '/reference'
      path: '/reference'
      fullPath: '/reference'
      preLoaderRoute: typeof ReferenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_data': {
      id: '/_data'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/library/': {
      id: '/library/'
      path: '/'
      fullPath: '/library/'
      preLoaderRoute: typeof LibraryIndexRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/help/': {
      id: '/help/'
      path: '/'
      fullPath: '/help/'
      preLoaderRoute: typeof HelpIndexRouteImport
      parentRoute: typeof HelpRoute
    }
    '/_data/': {
      id: '/_data/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DataIndexRouteImport
      parentRoute: typeof DataRoute
    }
    '/settings/viewers': {
      id: '/settings/viewers'
      path: '/viewers'
      fullPath: '/settings/viewers'
      preLoaderRoute: typeof SettingsViewersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/storage': {
      id: '/settings/storage'
      path: '/storage'
      fullPath: '/settings/storage'
      preLoaderRoute: typeof SettingsStorageRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/services': {
      id: '/settings/services'
      path: '/services'
      fullPath: '/settings/services'
      preLoaderRoute: typeof SettingsServicesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/help': {
      id: '/settings/help'
      path: '/help'
      fullPath: '/settings/help'
      preLoaderRoute: typeof SettingsHelpRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/reference/enzymes': {
      id: '/reference/enzymes'
      path: '/enzymes'
      fullPath: '/reference/enzymes'
      preLoaderRoute: typeof ReferenceEnzymesRouteImport
      parentRoute: typeof ReferenceRoute
    }
    '/library/primers': {
      id: '/library/primers'
      path: '/primers'
      fullPath: '/library/primers'
      preLoaderRoute: typeof LibraryPrimersRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/help/completion': {
      id: '/help/completion'
      path: '/completion'
      fullPath: '/help/completion'
      preLoaderRoute: typeof HelpCompletionRouteImport
      parentRoute: typeof HelpRoute
    }
    '/help/$topicId': {
      id: '/help/$topicId'
      path: '/$topicId'
      fullPath: '/help/$topicId'
      preLoaderRoute: typeof HelpTopicIdRouteImport
      parentRoute: typeof HelpRoute
    }
    '/_data/$': {
      id: '/_data/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof DataSplatRouteImport
      parentRoute: typeof DataRoute
    }
    '/_data/view/$fileId': {
      id: '/_data/view/$fileId'
      path: '/view/$fileId'
      fullPath: '/view/$fileId'
      preLoaderRoute: typeof DataViewFileIdRouteImport
      parentRoute: typeof DataRoute
    }
    '/_data/view/$fileId/': {
      id: '/_data/view/$fileId/'
      path: '/'
      fullPath: '/view/$fileId/'
      preLoaderRoute: typeof DataViewFileIdIndexRouteImport
      parentRoute: typeof DataViewFileIdRoute
    }
    '/_data/view/$fileId/searches': {
      id: '/_data/view/$fileId/searches'
      path: '/searches'
      fullPath: '/view/$fileId/searches'
      preLoaderRoute: typeof DataViewFileIdSearchesRouteImport
      parentRoute: typeof DataViewFileIdRoute
    }
    '/_data/view/$fileId/primers': {
      id: '/_data/view/$fileId/primers'
      path: '/primers'
      fullPath: '/view/$fileId/primers'
      preLoaderRoute: typeof DataViewFileIdPrimersRouteImport
      parentRoute: typeof DataViewFileIdRoute
    }
    '/_data/view/$fileId/history': {
      id: '/_data/view/$fileId/history'
      path: '/history'
      fullPath: '/view/$fileId/history'
      preLoaderRoute: typeof DataViewFileIdHistoryRouteImport
      parentRoute: typeof DataViewFileIdRoute
    }
    '/_data/view/$fileId/heatmap': {
      id: '/_data/view/$fileId/heatmap'
      path: '/heatmap'
      fullPath: '/view/$fileId/heatmap'
      preLoaderRoute: typeof DataViewFileIdHeatmapRouteImport
      parentRoute: typeof DataViewFileIdRoute
    }
    '/_data/view/$fileId/features': {
      id: '/_data/view/$fileId/features'
      path: '/features'
      fullPath: '/view/$fileId/features'
      preLoaderRoute: typeof DataViewFileIdFeaturesRouteImport
      parentRoute: typeof DataViewFileIdRoute
    }
    '/_data/view/$fileId/dotplot': {
      id: '/_data/view/$fileId/dotplot'
      path: '/dotplot'
      fullPath: '/view/$fileId/dotplot'
      preLoaderRoute: typeof DataViewFileIdDotplotRouteImport
      parentRoute: typeof DataViewFileIdRoute
    }
    '/_data/view/$fileId_/sequence/$sequenceId': {
      id: '/_data/view/$fileId_/sequence/$sequenceId'
      path: '/view/$fileId/sequence/$sequenceId'
      fullPath: '/view/$fileId/sequence/$sequenceId'
      preLoaderRoute: typeof DataViewFileIdSequenceSequenceIdRouteImport
      parentRoute: typeof DataRoute
    }
  }
}

interface DataViewFileIdRouteChildren {
  DataViewFileIdDotplotRoute: typeof DataViewFileIdDotplotRoute
  DataViewFileIdFeaturesRoute: typeof DataViewFileIdFeaturesRoute
  DataViewFileIdHeatmapRoute: typeof DataViewFileIdHeatmapRoute
  DataViewFileIdHistoryRoute: typeof DataViewFileIdHistoryRoute
  DataViewFileIdPrimersRoute: typeof DataViewFileIdPrimersRoute
  DataViewFileIdSearchesRoute: typeof DataViewFileIdSearchesRoute
  DataViewFileIdIndexRoute: typeof DataViewFileIdIndexRoute
}

const DataViewFileIdRouteChildren: DataViewFileIdRouteChildren = {
  DataViewFileIdDotplotRoute: DataViewFileIdDotplotRoute,
  DataViewFileIdFeaturesRoute: DataViewFileIdFeaturesRoute,
  DataViewFileIdHeatmapRoute: DataViewFileIdHeatmapRoute,
  DataViewFileIdHistoryRoute: DataViewFileIdHistoryRoute,
  DataViewFileIdPrimersRoute: DataViewFileIdPrimersRoute,
  DataViewFileIdSearchesRoute: DataViewFileIdSearchesRoute,
  DataViewFileIdIndexRoute: DataViewFileIdIndexRoute,
}

const DataViewFileIdRouteWithChildren = DataViewFileIdRoute._addFileChildren(
  DataViewFileIdRouteChildren,
)

interface DataRouteChildren {
  DataSplatRoute: typeof DataSplatRoute
  DataIndexRoute: typeof DataIndexRoute
  DataViewFileIdRoute: typeof DataViewFileIdRouteWithChildren
  DataViewFileIdSequenceSequenceIdRoute: typeof DataViewFileIdSequenceSequenceIdRoute
}

const DataRouteChildren: DataRouteChildren = {
  DataSplatRoute: DataSplatRoute,
  DataIndexRoute: DataIndexRoute,
  DataViewFileIdRoute: DataViewFileIdRouteWithChildren,
  DataViewFileIdSequenceSequenceIdRoute: DataViewFileIdSequenceSequenceIdRoute,
}

const DataRouteWithChildren = DataRoute._addFileChildren(DataRouteChildren)

interface HelpRouteChildren {
  HelpTopicIdRoute: typeof HelpTopicIdRoute
  HelpCompletionRoute: typeof HelpCompletionRoute
  HelpIndexRoute: typeof HelpIndexRoute
}

const HelpRouteChildren: HelpRouteChildren = {
  HelpTopicIdRoute: HelpTopicIdRoute,
  HelpCompletionRoute: HelpCompletionRoute,
  HelpIndexRoute: HelpIndexRoute,
}

const HelpRouteWithChildren = HelpRoute._addFileChildren(HelpRouteChildren)

interface LibraryRouteChildren {
  LibraryPrimersRoute: typeof LibraryPrimersRoute
  LibraryIndexRoute: typeof LibraryIndexRoute
}

const LibraryRouteChildren: LibraryRouteChildren = {
  LibraryPrimersRoute: LibraryPrimersRoute,
  LibraryIndexRoute: LibraryIndexRoute,
}

const LibraryRouteWithChildren =
  LibraryRoute._addFileChildren(LibraryRouteChildren)

interface ReferenceRouteChildren {
  ReferenceEnzymesRoute: typeof ReferenceEnzymesRoute
}

const ReferenceRouteChildren: ReferenceRouteChildren = {
  ReferenceEnzymesRoute: ReferenceEnzymesRoute,
}

const ReferenceRouteWithChildren = ReferenceRoute._addFileChildren(
  ReferenceRouteChildren,
)

interface SettingsRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsHelpRoute: typeof SettingsHelpRoute
  SettingsServicesRoute: typeof SettingsServicesRoute
  SettingsStorageRoute: typeof SettingsStorageRoute
  SettingsViewersRoute: typeof SettingsViewersRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsHelpRoute: SettingsHelpRoute,
  SettingsServicesRoute: SettingsServicesRoute,
  SettingsStorageRoute: SettingsStorageRoute,
  SettingsViewersRoute: SettingsViewersRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  DataRoute: DataRouteWithChildren,
  HelpRoute: HelpRouteWithChildren,
  LibraryRoute: LibraryRouteWithChildren,
  ReferenceRoute: ReferenceRouteWithChildren,
  SettingsRoute: SettingsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
